<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="p-view-page-title" class="mb-3">
              {{ measure.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('measure')">
                <GuideButton :guide="getGuide('measure')"></GuideButton>
              </span>
            </div>
            <span v-if="measure.measure_category && measure.measure_category.id" class="mr-2 ml-2">
              {{ $t('maintenance.measures.create.category_label') }}:
            </span>
            <span class="mr-1" v-if="measure.measure_category && measure.measure_category.id">
              <span class="badge badge-info mb-1">
                {{ measure.measure_category.name }}
              </span>
            </span>
            <span v-if="measure.value" class="mr-2 ml-2">
              {{ $t('maintenance.measures.create.value_label') }}:
            </span>
            <span class="mr-1" v-if="measure.value">
              <span class="badge badge-info mb-1">
                {{ $t('maintenance.measures.values.' + $options.filters.slugify(measure.value)) }}
              </span>
            </span>

          </div>

          <div class="col-md-6 text-right" qid="view-p-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.MEASURE_EDIT, permissions.MEASURE_EDIT_OWN], measure.created_by) && (!getClient.parent || (getClient.parent && measure.partition))"
                      class="btn btn-edit"
                      qid="edit-p-button"
                      @click="showEditPModal(measure)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.MEASURE_DELETE, permissions.MEASURE_DELETE_OWN], measure.created_by) && (!getClient.parent || (getClient.parent && measure.partition))"
                      class="btn btn-delete"
                      qid="delete-p-button"
                      @click="showConfirmDeleteModal(measure)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-p-modified-date">
                {{ measure.updated_at | formatDate }}
              </span>
              <Avatar v-if="measure.updated_by" :object="measure.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="measure.updated_by" qid="view-p-modified-by">
                {{ measure.updated_by.name }}
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-tabs class="mt-3">

      <!-- First tab -->
      <b-tab :title="$t('maintenance.measures.tab.basic_info')" active>
        <div class="card">
          <div class="card-body">
            <div class="content-view-body">
              <br>
              <div class="mt-3">
                <p class="text-dark">
                  {{ $t('maintenance.measures.create.description_label') }}
                </p>
                <hr>
                <p qid="measure-description" class="text-formatted">
                  {{ measure.description }}
                </p>
                <br>
              </div>

              <div class="mt-2">
                <p class="text-dark">
                  {{ $t('maintenance.measures.create.attachments') }}
                  &nbsp;
                  <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
                </p>
                <hr>
                <b-alert v-if="attachmentError.length"
                         show
                         variant="danger"
                         qid="attachments-p-error"
                >
                  {{ attachmentError }}
                </b-alert>
                <p v-for="file in measure.media">
                  <button class="float-right btn btn-link btn-inline-icons"
                          @click="openDeleteAttachmentModal(file)"
                          qid="remove-media-item"
                          v-if="isGranted([permissions.MEASURE_EDIT, permissions.MEASURE_EDIT_OWN], measure.created_by) && (!getClient.parent || (getClient.parent && measure.partition))"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </button>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a href="#" @click="downloadMedia(file)" qid="create-p-media-item">
                    {{ file.file_name }}
                  </a>
                </p>
                <label v-if="isGranted([permissions.MEASURE_EDIT, permissions.MEASURE_EDIT_OWN], measure.created_by) && (!getClient.parent || (getClient.parent && measure.partition))"
                       class="btn btn-secondary cursor-pointer"
                       qid="create-p-file-button"
                >
                  <input type="file"
                         name="fileupload"
                         value="fileupload"
                         multiple
                         id="file"
                         @change="onFileChange"
                         @click="resetFile"
                  >
                  <span>
                    <font-awesome-icon icon="cloud-upload-alt" />
                    {{ $t('system.upload') }}
                  </span>
                </label>
                <br>
              </div>
              <div class="mt-4">
                <p class="text-dark">
                  {{ $t('maintenance.measures.create.links_label') }}
                </p>
                <hr>
                <div v-if="measure.links">
                  <p v-for="link in measure.links" >
                    <button class="float-right btn btn-link btn-inline-icons"
                            @click="openDeleteLinkModal(link)"
                            qid="view-p-remove-link"
                            v-if="isGranted([permissions.MEASURE_EDIT, permissions.MEASURE_EDIT_OWN], measure.created_by) && (!getClient.parent || (getClient.parent && measure.partition))"
                    >
                      <font-awesome-icon icon="trash-alt" />
                    </button>
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
                <div v-if="showLinkInput">
                  <label class="mt-2">{{ $t('system.link') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLink"
                    :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                    qid="create-p-links"
                  ></b-form-input>
                  <label class="mt-2">{{ $t('table.name') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLinkName"
                    :placeholder="inputLink ? inputLink : $t('table.name')"
                    qid="create-p-links"
                  ></b-form-input>
                  <div class="text-right mt-2">
                    <span class="btn btn-success cursor-pointer mr-0"
                          id="inputGroup"
                          @click="handleLink"
                          qid="handle-link-save"
                    >
                      {{ $t('system.save') }}
                    </span>
                  </div>
                </div>
                <span class="btn btn-link cursor-pointer"
                      @click="showLinkInput = true"
                      qid="add-another-link"
                      v-if="isGranted([permissions.MEASURE_EDIT, permissions.MEASURE_EDIT_OWN], measure.created_by) && (!getClient.parent || (getClient.parent && measure.partition))"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
                </span>
                <br>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- Activity tab -->
      <b-tab :title="$t('maintenance.measures.tab.activities')"
             class="mt-3"
             @click="activityTabClicked"
             v-if="measure && measure.measure_category && checkScopeType('activity')"
      >
        <div v-if="showActivityTab">
          <ActivitiesTable :object="measure"></ActivitiesTable>
        </div>
      </b-tab>

      <!-- System tab -->
      <b-tab :title="$t('maintenance.measures.tab.systems')"
             class="mt-3"
             @click="systemTabClicked"
             v-if="measure && measure.measure_category && checkScopeType('system')"
      >
        <div v-if="showSystemTab">
          <SystemsTable :object="measure"></SystemsTable>
        </div>
      </b-tab>

      <!-- Contract tab -->
      <b-tab :title="$t('maintenance.measures.tab.third_parties')"
             class="mt-3"
             @click="thirdPartyTabClicked"
             v-if="measure && measure.measure_category && checkScopeType('third_party')"
      >
        <div v-if="showThirdPartyTab">
          <ThirdPartiesTable :object="measure"></ThirdPartiesTable>
        </div>
      </b-tab>

      <!-- Generic controls tab -->
      <b-tab :title="$t('maintenance.measures.tab.generic_controls')"
             class="mt-3"
             @click="controlTabClicked"
      >
        <div v-if="showControlTab">
          <GenericControlsTable :object="measure"></GenericControlsTable>
        </div>
      </b-tab>

      <!-- History tab -->
      <b-tab :title="$t('activities.tab.history')" class="mt-3" @click="historyTabClicked">
        <div v-if="showHistoryTab">
          <MeasureHistory :object="measure"></MeasureHistory>
        </div>
      </b-tab>

    </b-tabs>


    <!-- Edit measure modal template -->
    <b-modal ref="edit-measure" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-p-title">
          {{ $t('maintenance.measures.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editPFormSubmit" qid="edit-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-p-name-label">
              {{ $t('maintenance.measures.create.name_label') }}
            </label>
            <span class="text-red">*</span>
            <b-form-input
              qid="edit-p-form-name"
              type="text"
              v-model="pForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.measures.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-ac-pg-label">
              {{ $t('maintenance.measures.create.category_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="selectedCategory"
                :options="categoryItems"
                :placeholder="$t('maintenance.measures.create.category_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadCategories"
                track-by="slug"
                qid="create-ac-form-ac"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="edit-p-description-label">
              {{ $t('maintenance.measures.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-p-form-description"
              v-model="pForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.measures.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-implementation-status-label">
              {{ $t('maintenance.measures.create.value_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="pForm.value"
                :options="valueItems"
                :placeholder="$t('maintenance.measures.create.value_placeholder')"
                label="name"
                @select="valueSelected"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-implementation-status"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="pForm.value && pForm.value.value == 'number'">
            <label qid="create-p-implementation-status-label">
              {{ $t('maintenance.measures.create.currency_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="pForm.currency"
                :options="currencyItems"
                :placeholder="$t('maintenance.measures.create.currency_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-implementation-status"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="pForm.value && pForm.value.value == 'dropdown'">
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="responseType"
                :options="responseTypes"
                :placeholder="$t('maintenance.questions.create.type_placeholder')"
                label="name"
                @select="handleType"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value == 'Select' && pForm.value && pForm.value.value == 'dropdown'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptions">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeOptionItem(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <span>{{ option }}</span>
            </p>
            <div class="input-group">
              <b-form-input
                qid="create-p-form-link"
                type="text"
                v-if="showInput"
                v-on:keydown.enter="handleOption"
                v-model="inputOption"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"
              ></b-form-input>
              <div class="input-group-append" v-if="showInput">
                <span class="input-group-text cursor-pointer"
                      id="inputGroup"
                      @click="handleOption"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="showInput = true"
                  v-if="!showInput"
                  qid="create-p-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditPModal"
                    qid="edit-p-cancel-button"
          >
            {{ $t('maintenance.measures.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.measures.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete Policy confirm modal template -->
    <b-modal ref="delete-measure" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-p-title">
          {{ $t('maintenance.measures.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.measures.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.measures.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-p-cancel-button"
        >
          {{ $t('maintenance.measures.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteP(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-p-submit-button"
                  v-if="isGranted([permissions.MEASURE_DELETE, permissions.MEASURE_DELETE_OWN], itemToDelete.created_by)"
        >
          {{ $t('maintenance.measures.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

  </div>
</template>

<script>
import {initialsAvatarUrl} from '@/util/userAvatar.js';
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Validations from '@/views/Validations/Validations.vue';
import Avatar from '@/components/Avatar.vue';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import ActivitiesTable from '@/views/Measures/ActivitiesTable.vue';
import SystemsTable from '@/views/Measures/SystemsTable.vue';
import ThirdPartiesTable from '@/views/Measures/ThirdPartiesTable.vue';
import GenericControlsTable from '@/views/Measures/GenericControlsTable.vue';
import MeasureHistory from '@/views/Measures/MeasureHistory.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'MeasureView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.measures.title'),
          to: '/maintenance/measures'
        }
      ],
      measure: {},
      showLinkInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      inputLinkName: '',
      itemToDelete: {},
      pForm: {
        name: '',
        description: '',
        measure_category_id: '',
        value: [],
        currency: [],
        client:'',
        links: []
      },
      error: '',
      attachmentError: '',
      categoryItems: [],
      categoryInput: '',
      selectedCategory: [],
      valueItems: [
        { name: this.$t('maintenance.measures.values.none'), value: 'none' },
        { name: this.$t('maintenance.measures.values.date'), value: 'date' },
        { name: this.$t('maintenance.measures.values.number'), value: 'number' },
        { name: this.$t('maintenance.measures.values.dropdown'), value: 'dropdown' }
      ],
      value: [],
      currencyItems: [
        {name: 'None', value: 'None'},
        {name: 'DKK', value: 'DKK'},
        {name: 'EUR', value: 'EUR'},
        {name: 'GBP', value: 'GBP'},
        {name: 'USD', value: 'USD'}
      ],
      currency: [],
      responseTypes: [
        { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No' },
        { name: this.$t('maintenance.questions.type.select'), value: 'Select' }
      ],
      yesNoOptions: [
        'Yes',
        'No'
      ],
      responseType: [],
      selectedOptions: [],
      inputOption: '',
      positiveAnswers: [],
      negativeAnswers: [],
      allAnswers: [],
      allAnswersCopy: [],
      showInput: true,
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkModal: false,
      myGuides: [],
      showActivityTab: false,
      showControlTab: false,
      showSystemTab: false,
      showThirdPartyTab: false,
      showHistoryTab: false
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      } else {
        this.loadContent();
        this.loadCategories();
      }
    },
    selectedOptions: function (value) {
      let self = this
      this.allAnswers = value
      this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      _.forEach(this.positiveAnswers, function (answer) {
        self.handleAvailableAnswers(answer)
      })
      _.forEach(this.negativeAnswers, function (answer) {
        self.handleAvailableAnswers(answer)
      })
    }
  },
  components: {
    Validations,
    Avatar,
    ConfirmRemoveAttachment,
    ActivitiesTable,
    SystemsTable,
    ThirdPartiesTable,
    GenericControlsTable,
    MeasureHistory,
    GuideButton
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/measures')
    },
    checkScopeType(type) {
      let existingType = _.find(this.measure.measure_category.scope, function(item) {
        return item == type
      });
      return existingType
    },
    valueSelected(value) {
      if (value.value != 'dropdown') {
        this.selectedOptions = []
        this.responseType = []
      }
    },
    resetFile() {
      let imagefile = document.querySelector('#file');
      imagefile.value = '';
    },
    activityTabClicked() {
      this.showActivityTab = true;
      this.showSystemTab = false;
      this.showThirdPartyTab = false;
      this.showControlTab = false;
    },
    systemTabClicked() {
      this.showActivityTab = false;
      this.showSystemTab = true;
      this.showThirdPartyTab = false;
      this.showControlTab = false;
    },
    thirdPartyTabClicked() {
      this.showActivityTab = false;
      this.showSystemTab = false;
      this.showThirdPartyTab = true;
      this.showControlTab = false;
    },
    controlTabClicked() {
      this.showActivityTab = false;
      this.showSystemTab = false;
      this.showThirdPartyTab = false;
      this.showControlTab = true;
    },
    handleType(value) {
      this.positiveAnswers = []
      this.negativeAnswers = []
      if (value && value.value == 'Select') {
        this.allAnswers = this.selectedOptions
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      } else {
        this.allAnswers = this.yesNoOptions
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      }
    },
    handleOption(evt) {
      evt.preventDefault();
      // If there's a link in input, add it to links array
      if (this.inputOption !== '') {
        this.selectedOptions.push(this.inputOption)
        // Reset link input form
        this.inputOption = ''
      }
      this.showInput = false;
    },
    removeOptionItem(index, item) {
      let positiveIndex = _.findIndex(this.positiveAnswers, function(answer) { return answer == item })
      let negativeIndex = _.findIndex(this.negativeAnswers, function(answer) { return answer == item })

      this.selectedOptions.splice(index, 1);

      if (!this.selectedOptions.length) {
        this.showInput = true;
      }

      if (positiveIndex != -1) {
        this.positiveAnswers.splice(positiveIndex, 1)
      }
      if (negativeIndex != -1) {
        this.negativeAnswers.splice(negativeIndex, 1)
      }
    },
    handleAvailableAnswers(answer) {
      let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
      if (index != -1) {
        this.allAnswersCopy.splice(index, 1)
      }
    },
    expandAvailableAnswers(answer) {
      let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
      if (index == -1) {
        this.allAnswersCopy.push(answer)
      }
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance'
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    loadContent() {
      let self = this;
      piincHttp.get('measures/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.measure = response.data;
        // Push content name in breadcrumb array
        self.breadcrumbItems.push({text: self.measure.name, active: true});
      }, function() {});
    },
    openDeleteAttachmentModal(object) {
      this.selectedFile = object
      this.showDeleteAttachmentModal = true
    },
    closeDeleteAttachmentModal () {
      this.selectedFile = {}
      this.showDeleteAttachmentModal = false;
      // Remove last item in breadcrumbs, because it will be added again on load content
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    openDeleteLinkModal(object) {
      this.selectedLink = object
      this.showDeleteLinkModal = true
    },
    closeDeleteLinkModal () {
      this.selectedLink = {}
      this.showDeleteLinkModal = false;
      // Remove last item in breadcrumbs, because it will be added again on load content
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    handleCategoryInput(input) {
      this.categoryInput = input;
    },
    handleLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("model_type", this.measure.who_am_i);
      formData.append("model_id", this.measure.id);

      piincHttp.post('links', formData).then(function() {
        // Remove last item in breadcrumbs, because it will be added again on load content
        self.breadcrumbItems.pop();
        self.$toastr('success', self.$t('maintenance.measures.link_add_success'))
        self.loadContent()
        self.inputLink = ''
        self.inputLinkName = ''
        self.showLinkInput = false
      }, function() {})
    },
    downloadMedia(object){
      piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove()
        window.URL.revokeObjectURL(url);
      }, function() {});
    },
    onFileChange(file) {
      let files = file.target.files;
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      for (var i = 0; i < files.length; i++) {
        // Equal to 10 MB
        if (files[i].size > 10485760) {
          sizeError = true;
        }
        formData.append('document[]', files[i]);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.measure.who_am_i);
      formData.append("model_id", this.measure.id);

      if (sizeError) {
        this.attachmentError = this.$t('system.file_size')
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function() {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.$toastr('success', self.$t('maintenance.measures.media_add_success'))
          self.attachmentError = ''
          self.loadContent()
        }, function(error) {
          self.attachmentError = error.data.message;
          if (error.data.errors['document.0']) {
            self.attachmentError += ' ' + error.data.errors['document.0'][0]
          }
        })
      }
    },
    getUserAvatar(user){
      if (user && user.avatar) {
        return user.avatar;
      } else {
        return initialsAvatarUrl(user);
      }
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-measure'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-measure'].hide()
    },
    confirmDeleteP(object) {
      let self = this;
      piincHttp.delete('measures/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.measures.delete.success'))
      }, function() {});
    },
    showEditPModal(object) {
      let self = this;
      this.loadCategories();

      // Preselect category on edit modal
      this.selectedCategory = []
      if (object.measure_category) {
        _.find(this.categoryItems, function(item) {
          if (item.id == object.measure_category.id) {
            self.selectedCategory = item;
          }
        });
      }

      this.pForm.value = []
      if (object.value) {
        this.pForm.value = _.find(this.valueItems, function(item) {
          return item.value === object.value;
        });
      }

      this.pForm.currency = []
      if (object.currency) {
        this.pForm.currency = _.find(this.currencyItems, function(item) {
          return item.value === object.currency;
        });
      }

      this.responseType = []
      if (object.type) {
        this.responseType = _.find(this.responseTypes, function(item) {
          return item.value === object.type;
        });

        if (object.type == 'Select') {
          this.allAnswers = this.selectedOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        } else {
          this.allAnswers = this.yesNoOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        }
      }

      this.positiveAnswers = []
      if (object.type_positive_response) {
        let array = JSON.parse(object.type_positive_response)
        this.positiveAnswers.push(...array)
      }

      if (object.type == 'Select') {
        this.selectedOptions = []
        if (object.type_options) {
          let array = JSON.parse(object.type_options)
          this.selectedOptions.push(...array)
        }
      }

      this.pForm.slug = object.slug;
      this.pForm.name = object.name;
      this.pForm.description = object.description;
      this.$refs['edit-measure'].show()
    },
    hideEditPModal() {
      this.categoryInput = ''
      this.selectedOptions = []
      this.inputOption = ''
      this.positiveAnswers = []
      this.allAnswers = []
      this.showInput = true
      this.responseType = []
      this.$refs['edit-measure'].hide()
    },
    loadCategories() {
      let self = this;
      piincHttp.get('measure-categories', { params:
        {
          per_page: 100,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.categoryItems = response.data.items
        if (self.categoryItems && !self.categoryItems.length) {
          self.categoryItems.push({category: self.$t('system.no_results'), $isDisabled: true})
        }
      }, function() {});
    },
    editPFormSubmit(evt) {
      this.buttonDisabled = true;
      var moment = require('moment');
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.pForm.client = this.getClient.slug;

      if (this.selectedCategory && this.selectedCategory.id) {
        this.pForm.measure_category_id = this.selectedCategory.id
      } else {
        this.pForm.measure_category_id = ''
      }

      if (this.responseType && this.responseType.value) {
        this.pForm.type = this.responseType.value
      }

      if (this.selectedOptions && this.selectedOptions.length) {
        this.pForm.type_options = JSON.stringify(this.selectedOptions)
      } else {
        this.pForm.type_options = '[]'
      }

      if (this.positiveAnswers && this.positiveAnswers.length) {
        this.pForm.type_positive_response = JSON.stringify(this.positiveAnswers)
      } else {
        this.pForm.type_positive_response = '[]'
      }

      if (
        (this.selectedCategory && this.selectedCategory.id) &&
        (this.pForm.value && this.pForm.value.value) &&
        (
          (this.pForm.value.value == 'number' && this.pForm.currency && this.pForm.currency.value) ||
          ((this.pForm.value.value == 'dropdown' && this.responseType && this.responseType.value && ((this.responseType && this.responseType.value == 'Yes/No') || (this.responseType && this.responseType.value == 'Select' && this.selectedOptions && this.selectedOptions.length))) || (this.pForm.value.value == 'number' && this.pForm.currency && this.pForm.currency.value)) ||
          this.pForm.value.value == 'date' || this.pForm.value.value == 'none'
        )
      ){

        this.pForm.value = this.pForm.value ? this.pForm.value.value : '';
        this.pForm.currency = this.pForm.currency ? this.pForm.currency.value : '';

        piincHttp.put('measures/' + this.pForm.slug, this.pForm).then(function(response) {
          self.hideEditPModal();
          self.buttonDisabled = false;
          // If slug is not changed, just reload content
          if (response.data.slug === self.measure.slug) {
            // Remove last item in breadcrumbs, because it will be added again on load content
            self.breadcrumbItems.pop();
            self.loadContent();
          } else {
            // If slug changed, reload state with new param
            self.$router.push({ name: 'maintenance.measures.view', params: { slug: response.data.slug }})
          }
          self.$toastr('success', self.$t('maintenance.measures.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = ''
        this.buttonDisabled = false;

        if (!this.selectedCategory || !this.selectedCategory.id) {
          this.error +=  ' ' + this.$t('system.category_error_message')
        }
        if (!this.pForm.value || (this.pForm.value && !this.pForm.value.value)) {
          this.error +=  ' ' + this.$t('system.value_error_message')
        }
        if ((this.pForm.value && this.pForm.value.value == 'dropdown') && this.responseType && !this.responseType.value) {
          this.error +=  ' ' + this.$t('system.response_type_error_message')
        }
        if ((this.pForm.value && this.pForm.value.value == 'number') && this.pForm.currency && !this.pForm.currency.value) {
          this.error +=  ' ' + this.$t('system.currency_error_message')
        }
        if ((this.responseType && this.responseType.value == 'Select') && this.selectedOptions && !this.selectedOptions.length) {
          this.error +=  ' ' + this.$t('system.selected_options_error_message')
        }
      }
    },
    historyTabClicked() {
      this.showActivityTab = false;
      this.showSystemTab = false;
      this.showThirdPartyTab = false;
      this.showControlTab = false;
      this.showHistoryTab = true;
    }
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadContent();
      this.loadCategories();
    }
    this.loadGuides('measure');
  }
}
</script>
